<template>
    <div class="fw-msg">
        <div class="gl-items">
            <div class="gl-item" :style="style" @click="toKd">
                <span class="gl-item-name">快递管理</span>
            </div>
            <div class="gl-item1" :style="style"@click="toJd" v-if="!isCk">
                <span class="gl-item-name">金豆管理</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie,} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '消息提醒',
                fwUser: {},
                deptId: '',
                token: '',
                style: '',
                isCk: false,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.style = 'height:' + (parseInt(window.innerWidth / 2.8)) + 'px'
            this.getIsCk()
        },
        methods: {
            async getIsCk() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getIsCk", data)
                this.isCk = res.isCk
            },
            toKd(){
                this.$router.push('/kdgl')
            },

            toJd(){
                this.$router.push('/jdgl')
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-msg {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
        background-color: #FAFAFA;
    }

    .gl-items {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 5px;
    }

    .gl-item {
        width: 50%; /* 固定宽度 */
        margin: 10px 5px;
        background-image: url('../../assets/kdgl.png'); /* 注意路径 */
        background-size: cover;
        background-position: center;
    }

    .gl-item1 {
        width: 50%; /* 固定宽度 */
        margin: 10px 5px;
        background-image: url('../../assets/jdgl.png');
        background-size: cover;
        background-position: center;
    }

    .gl-item-name {
        display: block;
        padding: 20px;
        font-size: 16px;
    }

</style>